import Cta from './Cta'
import ErrorBoundary from 'components/error-boundary/ErrorBoundary'

function SecondaryCta(_props) {
  const { children, isSubmitting=null, submittingLabel="Enviando", ...rest } = _props
  return (
    <ErrorBoundary fallBack={ErrorFallback}>
      <Cta isSubmitting={isSubmitting} submittingLabel={submittingLabel} {...rest}>
        {children}
      </Cta>
    </ErrorBoundary>
  )
}

const ErrorFallback = () => <div className="text-error">Ocurrio un error</div>

export default SecondaryCta
